import { render } from "./leading-companies.vue?vue&type=template&id=22bda044"
import script from "./leading-companies.vue?vue&type=script&lang=js"
export * from "./leading-companies.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__